import type { DeviceMapping } from '@chukua/common';
import { Form, Input, Select } from 'antd';
import { ReportingDeviceSelect } from '../../../../integrations/features/gps/public/ReportingDeviceSelect';
import type { TruckClass } from '../../../../reference-data/reference-data.api';
import { TruckMakeModelFields } from '../../truck-models/public/TruckMakeModelFields';
import { TruckYearField } from '../../truck-models/public/TruckYearField';
import { VehicleColorField } from '../../../components/VehicleColorField';

interface TruckParticularsFieldsProps {
  truckClasses: TruckClass[];
  /** Absent on a new truck, which has no device of its own to keep in the picker. */
  truckId?: string;
  currentDevice?: DeviceMapping | null;
}

/** Class, make/model, year, GPS device, VIN, engine number and colour — shared by create and edit (CreateTruckDrawer, TruckDetailsForm). */
export function TruckParticularsFields({ truckClasses, truckId, currentDevice }: TruckParticularsFieldsProps) {
  return (
    <>
      <Form.Item name="classCode" label="Class" rules={[{ required: true, message: 'Select a class' }]}>
        <Select options={truckClasses.map((c) => ({ value: c.code, label: c.name }))} showSearch optionFilterProp="label" />
      </Form.Item>
      <TruckMakeModelFields />
      <div className="grid grid-cols-2 gap-3">
        <TruckYearField />
        <Form.Item name="device" label="GPS device">
          <ReportingDeviceSelect truckId={truckId} current={currentDevice} />
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="vin" label="VIN / chassis" rules={[{ required: true, message: 'Enter a VIN' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="engineNumber" label="Engine number" rules={[{ required: true, message: 'Enter an engine number' }]}>
          <Input />
        </Form.Item>
      </div>
      <VehicleColorField />
    </>
  );
}
